export default "__VITE_ASSET__153361a0__"